import React from 'react';

import {
  Chip,
  styled
} from '@mui/material';



export type IShippingStatus = 'awaitingShipment' | 'inTransit' | 'pending' | 'delivered';



const StyledChip = styled(Chip, {
  shouldForwardProp: propName => propName !== 'shippingStatus'
})<{
  shippingStatus: IShippingStatus;
}>(({
  theme,
  shippingStatus
}) => ({
  textTransform: 'uppercase',
  fontSize: 10,
  background: shippingStatus === 'delivered' ? theme.palette.warning.light : theme.palette.primary.light,
  color: shippingStatus === 'delivered' ? theme.palette.warning.main : theme.palette.primary.main,
  fontWeight: 'bold'
}));



export interface IProps {
  shippingStatus: IShippingStatus;
}

export const FC: React.FC<IProps> = props => {
  return (
    <StyledChip
      shippingStatus={props.shippingStatus}
      size="small"
      label={__shippingStatus2Label[props.shippingStatus]} />
  );
};



const __shippingStatus2Label: Record<IShippingStatus, string> = {
  awaitingShipment: 'Awaiting Shipment',
  delivered: 'Delivered',
  inTransit: 'In Transit',
  pending: 'Pending'
};
